import { useEffect } from "react";
import { useLogoStore } from "./state/logoStore";
import { StartPage } from "./pages/StartPage";
import { OnboardingPage } from "./pages/OnboardingPage";
import { TemplatesPage } from "./pages/TemplatesPage";
import { GeneratedPage } from "./pages/GeneratedPage";
import { EditorPage } from "./pages/EditorPage";
import { GifMakerPage } from "./pages/GifMakerPage";
import { QrMakerPage } from "./pages/QrMakerPage";
import { PosterTilerPage } from "./pages/PosterTilerPage";
import { ThreeDLogoPage } from "./pages/ThreeDLogoPage";
import { SoundToggle } from "./components/SoundToggle";
import { MusicPlayer } from "./components/MusicPlayer";
import { TopDock } from "./components/TopDock";
import { useButtonSounds } from "./hooks/useButtonSounds";

const HASH_PAGES = new Set([
  "start", "templates", "editor", "onboarding", "generated", "gif-maker", "qr-maker", "poster-tiler", "threed",
] as const);
type HashPage = typeof HASH_PAGES extends Set<infer T> ? T : never;

export function App() {
  useButtonSounds();
  const page = useLogoStore((s) => s.currentPage);

  // Honor `/#qr-maker` style links (used by the standalone 3D Logo page's dock).
  // Read once on mount, switch to that page if valid, then strip the hash so a
  // refresh doesn't keep dragging the user back to it.
  useEffect(() => {
    const hash = window.location.hash.replace(/^#/, "");
    if (hash && HASH_PAGES.has(hash as HashPage)) {
      useLogoStore.getState().setPage(hash as HashPage);
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }
  }, []);

  const pageEl =
    page === "onboarding" ? <OnboardingPage /> :
    page === "templates"  ? <TemplatesPage />  :
    page === "generated"  ? <GeneratedPage />  :
    page === "editor"     ? <EditorPage />     :
    page === "gif-maker"  ? <GifMakerPage />   :
    page === "qr-maker"   ? <QrMakerPage />    :
    page === "poster-tiler" ? <PosterTilerPage /> :
    page === "threed"     ? <ThreeDLogoPage /> :
    <StartPage />;
  return (
    <>
      {pageEl}
      <TopDock />
      <SoundToggle />
      <MusicPlayer />
    </>
  );
}
